import VQRLanding from './VQRLanding';

function App() {
  return <VQRLanding />;
}

export default App;